<template>
  <div class="home">
    <!-- banner -->
    <div class="banner">
      <el-carousel height="450px" :autoplay="false">
        <el-carousel-item>
          <img v-bind:src="bannerlist" />
          <div class="banner-nav">
            <img src="../assets/banner1-icon.png" class="banner-icon1" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="banner-nav">
        <div class="nav">
          <p>
            <router-link to="/login-person" active-class="active">个人登录</router-link>
          </p>
          <p>
            <router-link to="/login-company" active-class="active">公司登录</router-link>
          </p>
          <p>
            <router-link to="/login-hospital" active-class="active">医院登录</router-link>
          </p>
        </div>
        <img src="../assets/home-banner-wei.png" class="home-banner-w" />
      </div>
    </div>
    <!-- content -->
    <div class="content-continer home-content">
      <el-row :gutter="25">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="list-header">
              <img src="../assets/msg-icon3.png" />常见问题
              <router-link to="/notice/8" class="more right">更多>></router-link>
            </div>
            <ul>
              <li
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
                v-for="item in list1"
                :key="item"
              >
                <router-link :to="`/Msg/`+item.newsId">{{item.newsTitle}}</router-link>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="list-header">
              <img src="../assets/msg-icon2.png" />通知公告
              <router-link to="/notice/7" class="more right">更多>></router-link>
            </div>
            <ul>
              <li
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
                v-for="item in list2"
                :key="item"
              >
                <router-link :to="`/Msg/`+item.newsId">{{item.newsTitle}}</router-link>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="list-header">
              <img src="../assets/msg-icon1.png" />行业动态
              <router-link to="/notice/6" class="more right">更多>></router-link>
            </div>
            <ul>
              <li
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
                v-for="item in list3"
                :key="item"
              >
                <router-link :to="`/Msg/`+item.newsId">{{item.newsTitle}}</router-link>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer-url">
      <ul class="content-continer">
        <li>
          <a href="http://www.nhc.gov.cn/" target="_blank">
            <img src="../assets/1.png" />国家卫生健康委员会
          </a>
        </li>
        <li>
          <a href="http://www.nmpa.gov.cn/WS04/CL2042/" target="_blank">
            <img src="../assets/1.png" />国家药品监督管理局
          </a>
        </li>
        <li>
          <a href="http://kw.beijing.gov.cn/" target="_blank">
            <img src="../assets/2.png" />北京市科学技术委员会
          </a>
        </li>
        <li>
          <a href="http://www.chinadctc.org/index.html" target="_blank">
            <img src="../assets/3.png" />中国药理学会药物临床试验专业委员会
          </a>
        </li>
        <!-- <li>
          <a href="http://www.cha.org.cn/" target="_blank">
            <img src="../assets/4.png" />中国医院协会
          </a>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import userPath from "../assets/banner1.png";
import { gethomelist } from "@/request/api";
import { loginInOut3 } from "@/request/api";
import Cookies from "js-cookie";
export default {
  name: "home",
  data() {
    return {
      bannerlist: userPath,
      list1: "",
      list2: "",
      list3: ""
    };
  },
  methods: {
    // 鼠标移入加入class
    changeActive($event) {
      $event.currentTarget.className = "list-active";
    },
    removeActive($event) {
      $event.currentTarget.className = "";
    }
  },
  mounted() {
    gethomelist(8, 11, 7)
      .then(res => {
        this.list1 = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
    gethomelist(7, 11, 7)
      .then(res => {
        this.list2 = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
    gethomelist(6, 11, 7)
      .then(res => {
        this.list3 = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
    let that = this;
    let unionId1 = this.$utils.getUrlKey("unionId");
    Cookies.set("unionId", unionId1);
    if (unionId1) {
      let data = {
        unionId: unionId1
      };
      loginInOut3(data)
        .then(res => {
          if (res.data.code == "00000") {
            Cookies.set("token", res.data.data.token);
            Cookies.set("userid", res.data.data.userId);
            console.log(res.data.data.token);
            that.$message({
              message: "登录成功",
              type: "success"
            });
            if (res.data.data.accountType == "1") {
              that.$router.replace("/CIndex/company-home"); //公司登录
            } else if (res.data.data.accountType == "2") {
              that.$router.replace("/HIndex/hostipal-home");
            } else {
              that.$router.push("/person-home");
            }
          } else {
            that.$router.replace("/Bind");
            that.$message.success(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    console.log("dsfsfd");
    console.log(Cookies.get("token"));
    console.log(Cookies.get("accountType"));
    if (Cookies.get("token") == "" || Cookies.get("token") == undefined) {
      console.log("token没有");
    } else {
      console.log("token有");
      console.log(Cookies.get("accountType"));
      if (Cookies.get("accountType") == "1") {
        if (Cookies.get("isAdmin") == "8") {
          this.$router.replace("/hospitalaudit/hostla");
        } else {
          this.$router.replace("/CIndex/company-home"); //公司登录
        }
      } else if (Cookies.get("accountType") == "2") {
        this.$router.replace("/HIndex/hostipal-home");
      } else if (Cookies.get("accountType") == "3") {
        this.$router.push("/person-home");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  position: relative;
}

.banner-nav {
  top: 0px;
  position: absolute;
  z-index: 1000;
  width: 1100px;
  height: 450px;
  left: 50%;
  transform: translate(-50%);
}

.nav {
  position: absolute;
  right: 0px;
  background: rgba(13, 85, 176, 0.66);
  width: 420px;
  height: 450px;
  padding: 38px 45px;
  box-sizing: border-box;
}

.nav p {
  width: 330px;
  height: 100px;
  background: #fff;
  line-height: 100px;
  margin-bottom: 37px;
}

.nav p a {
  color: #4a88d3;
  font-size: 16px;
  padding-left: 150px;
  width: 100%;
  height: 100%;
  display: block;
  box-sizing: border-box;
}

.nav p:first-child {
  background: url("../assets/person-login.png") no-repeat;
  background-size: 100%;
}

.nav p:nth-child(2) {
  background: url("../assets/company-login.png") no-repeat;
  background-size: 100%;
}

.nav p:nth-child(3) {
  background: url("../assets/hos-login.png") no-repeat;
  background-size: 100%;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #f6faff;
}

.bg-purple {
  background: #f6faff;
  height: 340px;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f6faff;
}

.home-content {
  margin-top: 50px;
  margin-bottom: 50px;
}

.list-header {
  height: 60px;
  background: rgba(54, 114, 191, 1);
  border-radius: 4px;
  line-height: 60px;
  color: #fff;
  padding-left: 27px;
  text-align: left;
  font-size: 14px;
}

.list-header img {
  vertical-align: middle;
  margin-right: 14px;
}

.grid-content li {
  text-align: left;
  padding: 0px 26px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #4c4c4c;
  box-sizing: border-box;
  cursor: pointer;
}
.grid-content li a {
  width: 100%;
  display: block;
  font-size: 14px;
  color: #4c4c4c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-active {
  background: #fff0eb;
  color: #ec6c44 !important;
}

.banner-icon1 {
  position: absolute;
  top: 100px;
  left: 0px;
  z-index: 999;
}

.footer-url {
  height: 70px;
  background: rgba(246, 246, 246, 1);
}

.footer-url li {
  line-height: 70px;
  display: inline-block;
  /* padding: 0px 40px; */
  /* margin-right: 32px; */
  margin-right: 89px;
  /* border: 1px solid red; */
}

.footer-url li a {
  font-size: 14px;
  color: #4c4c4c;
  cursor: pointer;
}

.footer-url li:last-child {
  margin-right: 0px;
}

.footer-url li img {
  vertical-align: middle;
  margin-right: 15px;
}

a.more {
  color: #fff;
  font-size: 13px;
  margin-right: 20px;
  cursor: pointer;
}
.home-banner-w {
  position: absolute;
  right: -234px;
  top: -3px;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue